export const defaultContractSettings = {
  contractProductTitle: "vehicle",
  showAdditionalDriver: true,
  showCompanyCustomerFields: true,
  showContractAgreementDetails: true,
  showCustomerAdditionalInformationField: false,
  showDeductibleField: true,
  showDriverFields: true,
  showExportField: true,
  showLocation: true,
  showPostDebit: true,
  showPrices: true,
  showRegistrationPlateField: true,
  showVehicleDamagesMap: false,
  showVehicleFuelFields: true,
  showVehicleMileage: true,
  showVehicleExtraInfo: true,
  showPaymentStatus: true,
  showProductInformation: true,
  showContractAdditionalAgreement: false,
};
